module.exports = __webpack_public_path__ + "static/media/obstacles.84e6d46b.jpg";